import { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { csv } from 'd3-fetch'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { scaleLinear } from 'd3-scale'
import { Theme } from '../../styles/settings/theme'
import Subtitle from '../atoms/Subtitle'
import { Flex } from '../atoms/Basics'

const COLORS = {
  region: 'blue',
  org: 'orange',
  role: 'green'
}

const Container = styled.div`
  margin: 1rem;
`

const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.color};
  color: ${(props) => props.theme.colors.white};
  border-radius: 50%;
  width: ${(props) => props.width}px;
  height: ${(props) => props.width}px;
  font-size: ${(props) => props.theme.fontSizes[0]};
  font-weight: bold;
  mix-blend-mode: multiply;
`
const DataFlex = styled(Flex)`
  padding-top: ${(props) => props.theme.space[3]}px;
`
const RowFlex = styled(Flex)`
  height: 2.9rem;
`
const LabelFlex = styled(Flex)`
  height: 2.9rem;
  margin-left: 1rem;
  ${Mq.md} {
    font-size: ${(props) => props.theme.fontSizes[0]};
  }
`
const TopicChart = ({ topic, selectedYear = 'All Years' }) => {
  const [data, setData] = useState(null)
  const [allData, setAllData] = useState(null)

  useEffect(() => {
    const csvData =
      topic === 'region'
        ? process.env.PUBLIC_URL + '/data/demographicsRegion.csv'
        : topic === 'org'
        ? process.env.PUBLIC_URL + '/data/demographicsOrg.csv'
        : topic === 'role'
        ? process.env.PUBLIC_URL + '/data/demographicsRole.csv'
        : null
    csv(csvData).then((data) => {
      setAllData(data)
    })
  }, [topic])

  useEffect(() => {
    if (allData) {
      // Check if year column exists
      const hasYearColumn = allData.length > 0 && allData[0].hasOwnProperty('year')
      
      if (hasYearColumn) {
        // Filter data by selected year and sort
        const filteredData = allData.filter(row => row.year === selectedYear)
        filteredData.sort((a, b) => b.n - a.n)
        setData(filteredData)
      } else {
        // If no year column, just use all data and sort
        const sortedData = [...allData].sort((a, b) => b.n - a.n)
        setData(sortedData)
      }
    }
  }, [selectedYear, allData])

  const x = scaleLinear([-20, 80], [0, 90])

  return (
    <Container>
      <Subtitle
        text={data?.[0]?.topic ?? null}
        size={Theme.fontSizes[4]}
        color={Theme.colors[COLORS[topic]]}
      ></Subtitle>
      <DataFlex>
        <Flex flexDirection="column" justifyCenter="center" alignItems="center">
          {data?.map((d) => (
            <RowFlex key={d.group} justifyContent="center" alignItems="center">
              <Circle color={Theme.colors[COLORS[topic]]} width={x(d.percent)*1.3}>
                {d.n}
              </Circle>
            </RowFlex>
          ))}
        </Flex>
        <Flex flexDirection="column">
          {data?.map((d, i) => (
            <LabelFlex key={`${d.group} + i`} alignItems="center">
              {d.group}
            </LabelFlex>
          ))}
        </Flex>
      </DataFlex>
    </Container>
  )
}

export default TopicChart
